import React from 'react';

const AnalyticsPage = ({ pageTitle }) => {
    return <></>;
};

export default AnalyticsPage;
